import styled from "styled-components";
import {LIVE_CASINO_PAGE_WRAPPER} from "../../../../themes/css-global-classes";

export const LobbyHeaderTitleContainerBox = styled.div`
  display: flex;
  width: 100%;
  min-height: 4rem;
  padding-left: 4rem;
  padding-right: 4rem;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 1rem;
  }

  .${LIVE_CASINO_PAGE_WRAPPER} & {
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      margin-bottom: 0;
    }
  }
`;
